import { render, staticRenderFns } from "./blockEvaluationModal.vue?vue&type=template&id=0abf803d&"
import script from "./blockEvaluationModal.vue?vue&type=script&lang=js&"
export * from "./blockEvaluationModal.vue?vue&type=script&lang=js&"
import style0 from "./blockEvaluationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports